import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { ScoutPath, ScoutPoint, ScoutPointEnvData } from '../../../core/models';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import { NgForm, ControlContainer } from '@angular/forms';
import { AppState } from '../../../core';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';


@Component({
  selector: 'app-scout-point-environment',
  templateUrl: './scout-point-environment.component.html',
  styleUrls: ['./scout-point-environment.component.scss']
})
export class ScoutPointEnvironmentComponent extends FesBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() scoutPath : ScoutPath
  @Input() scoutPoint : ScoutPoint
  @Input() scoutTaskDoc : ScoutTaskDoc
  @Input() isEditing : boolean
  @Input() showTitlebar : boolean = false
  @ViewChild('scoutPointEnvForm') scoutPointEnvForm: NgForm;
  @Output('editChange') editChange = new EventEmitter<NgForm>()
  @Output() editModeChanged = new EventEmitter<ScoutPointEnvironmentComponent>()

  constructor(appState:AppState) { super(appState) }

  ngOnInit(): void {
    if ( this.scoutPoint && !this.scoutPoint.envData ) {
      this.scoutPoint.envData = new ScoutPointEnvData()
    }
  }

  ngAfterViewInit(): void {
    this.subscribe(this.scoutPointEnvForm.statusChanges, status => this.editChange.emit(this.scoutPointEnvForm))
    this.subscribe(this.scoutPointEnvForm.valueChanges, change => this.editChange.emit(this.scoutPointEnvForm))
  }

  ngOnDestroy(): void {
    super.destroy()
  }

  onValueClicked() {
    if ( !this.isEditing ) {
      this.isEditing = true
      this.editModeChanged.emit(this)
    }
  }
}
